import script from "./IncomeDateHandler.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeDateHandler.vue?vue&type=script&setup=true&lang=js"

import "./IncomeDateHandler.vue?vue&type=style&index=0&id=2a55f227&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a55f227"]])

export default __exports__